import {UIComponent} from "@/engine/UI/UIComponent.js";
import {UICExportHelper} from "@/engine/UIcomponents/UICExportHelper.js";
import {sm} from "@/context/global.js";

export class UICExportImage extends UIComponent {
    constructor(options, view = "imageExportWindowContent") {
        super(options, view);
        this.id = 'imageExport'
        this.title = 'Create image'
        this.mainActionName = 'CREATE IMAGE'
        this.cancelActionName = 'CANCEL'
        this.className = 'pdf-control'
        if (!this.pdf) {
            console.error("pdf isn't defined")
        }
        if (!this.map) {
            console.error("map isn't defined")
        }
        this.abortReason = ''
    }

    open(container, parent, data) {
        data = {}
        if (this.area && this.area instanceof L.Polyline) {
            data.isGeometry = true
        }
        data.hasRasterArea = this.rasterArea

        super.open(container, parent, data)

        let el = this.el.bind(this)

        this.pdf.setArea(this.area)
        this.progressNode = document.createElement("div")
        Object.assign(this.progressNode, {className: 'pdf-progress'});
        this.pdf.progressDiv.append(this.progressNode)
        this.progressLabel = document.createElement("div")
        this.progressNode.append(this.progressLabel)

        // create event handlers
        el('size').addEventListener("change", this._updateSettings.bind(this));
        el('padding').addEventListener("change", this._updateSettings.bind(this));
        el('area-square').addEventListener("change", this._updateSettings.bind(this));
        el('type').addEventListener("change", this._updateSettings.bind(this));

        this.map.on("imagePdf:progress", this._onProgress, this)
        this.map.on("imagePdf:aborted", this._onAborted, this)

        this._updateSettings()
    }

    close() {
        this.pdf.setArea()
        this.map.off("imagePdf:progress", this._onProgress, this)
        this.map.off("imagePdf:aborted", this._onAborted, this)
        this.progressNode.remove()
        super.close()
    }

    onMainAction() {
        let savedExcludeNodesWithCSS = this.pdf.options.excludeNodesWithCSS
        let excludeNodesWithCSS = UICExportHelper._createLayersFilterFromCheckboxes(this.el.bind(this))
        this.pdf.options.excludeNodesWithCSS = UICExportHelper._addToTargetArray(this.pdf.options.excludeNodesWithCSS, excludeNodesWithCSS)

        this.map.once("imagePdf:finish", function (data) {
            if (data.blob) {
                sm.noticeMessage("Image has been created, see browser download files.")
            } else {
                if (this.abortReason === '') {
                    sm.noticeMessage("Image creating has been aborted due the error.")
                } else {
                    sm.noticeMessage("Image export operation has been aborted due the error: " + this.abortReason)
                }
            }
            this.pdf.options.excludeNodesWithCSS = savedExcludeNodesWithCSS
        }.bind(this))
        this.pdf.setImageFormat(this.el('type').value)

        this.pdf.createImage(
            this.el('size').value,
            this.el('padding').value,
            this.el('area-square').checked,
            true
        )
        return false
    }

    onCancelAction() {
        this.close()
        super.onCancelAction();
        return true
    }

    _updateSettings() {
        let el = this.el.bind(this)

        this.pdf.setImageFormat(el('type').value)

        let id = this.pdf.calcImages(
            el('size').value,
            el('padding').value,
            el('area-square').checked
        )

        if (!id) {
            el("spec").hidden = true
            return
        }

        let w
        let h
        if (el('area-square').checked) {
            w = el('size').value
            h = w
        } else {
            let scale = id.dimensions.wpx / id.dimensions.hpx
            if (id.dimensions.wpx > id.dimensions.hpx) {
                w = el('size').value
                h = Math.floor(el('size').value / scale)
            } else {
                h = el('size').value
                w = Math.floor(el('size').value * scale)
            }

        }

        el("resolution").innerHTML = `${w} x ${h}`
        el("spec").hidden = false

        this.pdf.showImageRegions(id)

        return id
    }

    _onProgress(p) {
        if (p.operation === "tile") {
            let percent = Math.ceil((p.itemNo / p.totalItems) * 100)
            this.progressLabel.innerText = `Creating image: ${percent}%`;
        }
    }

    _onAborted(p) {
        if (p.reason === "timeout") {
            this.abortReason = "timeout with loading map images, check your network connection and try again"
        }
    }
}
